import pick from 'lodash/pick';
import { ColorVariant } from './color-variant';
export var BlockSimpleColor = pick(ColorVariant, ['White', 'Gray', 'Blue']);